import styled from 'styled-components';

export default styled.div`
    margin-bottom: 10px;
    /* margin-left: 20px;
    margin-right: 20px; */
`;